import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { deleteInteractionLog, getInteractionLog, getInteractionsLogs } from './api';
import { InteractionLogResponse } from './types';
import { queryClient } from 'providers/AllProviders';
import { useParams } from 'react-router-dom';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function useGetInteractionsLogs(
  params?: Record<string, any>,
  options?: UseQueryOptions<{ data: InteractionLogResponse[]; meta: MetaApiResponse }, Error>
) {
  const { workspaceId, agentId } = useParams<{ workspaceId: string; agentId: string }>();

  return useQuery<{ data: InteractionLogResponse[]; meta: MetaApiResponse }>({
    queryKey: ['callLogs', workspaceId, agentId, params],
    queryFn: () => getInteractionsLogs(workspaceId!, agentId!, params),
    enabled: Boolean(workspaceId && agentId),
    ...options
  });
}

export function useGetInteractionLog(options?: UseQueryOptions<InteractionLogResponse, Error>) {
  const { workspaceId, agentId, id } = useParams<{ workspaceId: string; agentId: string; id: string }>();

  return useQuery<InteractionLogResponse>({
    queryKey: ['callLog', workspaceId, agentId, id],
    queryFn: () => getInteractionLog(workspaceId!, agentId!, id!),
    enabled: Boolean(workspaceId && agentId && id),
    ...options
  });
}

export function useDeleteInteractionLog() {
  const { workspaceId, agentId } = useParams<{ workspaceId: string; agentId: string }>();

  return useMutation({
    mutationFn: (id: number) => deleteInteractionLog(workspaceId!, agentId!, id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['callLogs'],
        refetchType: 'active'
      });
    }
  });
}
